/**
 * 결제 결과 페이지
 * FSD: pages/payment-result
 */

import React from 'react';
import {
  usePaymentApproval,
  PaymentSuccess,
  PaymentError,
  PaymentLoading,
} from '@/features/subscription/payment-result';

const PaymentResultPage: React.FC = () => {
  const { status, message, transactionId } = usePaymentApproval();

  return (
    <div className="payment-result-page">
      <div className="payment-result-container">
        {status === 'loading' && <PaymentLoading />}
        {status === 'success' && (
          <PaymentSuccess message={message} transactionId={transactionId} />
        )}
        {status === 'error' && <PaymentError message={message} />}
      </div>
    </div>
  );
};

export default PaymentResultPage;
